// src/components/ui/select.js
import React from "react";

/**
 * Componente Select
 * 
 * Props:
 * - value: valor seleccionado (controlado)
 * - onValueChange: función que se llama cuando cambia el valor
 * - placeholder: texto que se muestra cuando no hay valor seleccionado
 * - className: clases adicionales para el contenedor
 * - children: opciones (SelectItem)
 */
export const Select = ({
  children,
  className = "",
  value,
  onValueChange,
  placeholder = "Seleccione...",
  ...props
}) => {
  const handleChange = (e) => {
    if (onValueChange) {
      onValueChange(e.target.value);
    }
  };

  return (
    <div className={`relative inline-block w-full ${className}`}>
      <select
        value={value}
        onChange={handleChange}
        className="w-full border px-3 py-2 rounded appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500"
        {...props}
      >
        {/* Si se proporciona placeholder, lo agregamos como primera opción */}
        {placeholder && <option value="">{placeholder}</option>}
        {children}
      </select>
    </div>
  );
};

/**
 * Componente SelectItem: simplemente renderiza una opción del <select>
 */
export const SelectItem = ({ value, children }) => {
  return <option value={value}>{children}</option>;
};
